import { Alert as AntdAlert, AlertProps } from 'antd';

import styled, { StyledProp, css } from '@/styled';

const Alert = ({ className, ...props }: AlertProps & StyledProp) => {
  return (
    <div className={className}>
      <AntdAlert {...props} />
    </div>
  );
};

export default styled(Alert)`
  ${({ theme }) => css`
    margin-top: ${theme.space.pxToRem(24)};

    .ant-alert-action {
      margin: auto 0;
      align-self: flex-end;

     > button {
        border: none;
        display: flex;
        align-items: center;
        gap: ${theme.space.pxToRem(8)};
      }
    }


    .ant-alert-message {
      font-size: ${theme.space.pxToRem(24)};
      margin-bottom: ${theme.space.pxToRem(16)};
      font-weight: 500;
      line-height: 100%;
    }

    .ant-alert-close-icon {
      right: 24px;
      position: absolute;
    }

    .ant-alert-description {
      font-size: ${theme.space.pxToRem(16)};
      margin-bottom: ${theme.space.pxToRem(32)};
    }

    .ant-alert-error {
      flex-direction: column;
      align-items: flex-start;
      border: 0;
      padding-inline: ${theme.space.pxToRem(24)};
      padding-block: ${theme.space.pxToRem(24)};
      background: ${theme.variables.bgComponentsContainer};

      .ant-alert-message,
      .ant-alert-description,
    }
  `}
`;
